export default __webpack_public_path__ + "static/media/note-screenshot-05.b9bd58fc.png";